<template>
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 0px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="80px"
      >
        <el-form-item label="项目状态" prop="xmzt">
          <el-select
            ref="xmzt"
            v-model="listQuery.xmzt"
            placeholder="项目状态"
            filterable
            multiple
            collapse-tags
            size="small"
            class="filter-item"
            style="width: 200px"
            @change="handleChangeXmzt"
          >
            <el-option
              v-for="item in common.dictList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目" prop="bmmc">
          <el-select
            ref="bmmc"
            v-model="listQuery.xmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            @change="handleChangeXm"
            style="width: 200px"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属计划" prop="txlx">
          <el-select
            ref="txlx"
            v-model="listQuery.planId"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in xgpg.planList"
              :key="item.id"
              :label="item.plan_year + '-' + item.plan_name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关键动作" prop="linkPointName">
          <el-select
            v-model="listQuery.linkPointName"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in gjdzList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="评估类型" prop="pglx">
          <el-select
            ref="name"
            v-model="listQuery.pglx"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in xgpg.pglxList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="当前节点" prop="linkPointName">
          <el-select
            v-model="listQuery.linkPointName"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in gjdzList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item> -->

        <el-form-item label="咨询总监" prop="zxzj">
          <el-select
            ref="zxzj"
            v-model="listQuery.zxzj"
            placeholder="咨询总监"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            collapse-tags
          >
            <el-option
              v-for="item in zxzjList"
              :key="item.ygbh"
              :label="item.xm"
              :value="item.ygbh"
            />
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="评审人" prop="sun">
          <treeselect
            v-model="listQuery.psr"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 200px; line-height: 32px"
            size="small"
          />
        </el-form-item> -->
        <el-form-item label="评审状态" prop="bmmc">
          <el-select
            v-model="listQuery.status"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请人" prop="sun" class="pscx-treeselect">
          <div>
            <treeselect
              v-model="listQuery.applicant"
              placeholder="请选择"
              :options="deptUser"
              :disable-branch-nodes="true"
              :show-count="true"
              value-consists-of="LEAF_PRIORITY"
              no-results-text="未搜到任何结果"
              :clear-on-select="true"
              :normalizer="normalizer"
              style="width: 200px; line-height: 30px"
              size="small"
            />
          </div>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="search"
            >查询</el-button
          >
          <el-button
            type="primary"
            style="margin-left: 15px"
            size="small"
            @click="exportList()"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        border
        stripe
        size="mini"
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="所属项目"
          prop="xmmc"
          min-width="200px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属计划"
          prop="jhmc"
          min-width="250px"
          align="left"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.jhmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="关键动作"
          prop="gjdz"
          :show-overflow-tooltip="true"
          min-width="130px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.gjdz }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="当前节点"
          prop="gjdz"
          :show-overflow-tooltip="true"
          min-width="170px"
          align="left"
        >
          <template slot-scope="scope">
              <span>{{ scope.row.gjdz }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="评估类型"
          prop="pglxmc"
          :show-overflow-tooltip="true"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.pglxmc }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="已评审次数"
          prop="pscs"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.pscs }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          :show-overflow-tooltip="true"
          label="申请人"
          prop="sqr"
          min-width="80px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sqr }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="咨询总监"
          prop="zxzj"
          min-width="80px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.zxzj }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          :show-overflow-tooltip="true"
          label="评审人"
          prop="sqr"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.sqr }}</span>
          </template>

        </el-table-column> -->
        <el-table-column
          label="评审状态"
          prop="status"
          min-width="100px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.status | typeStata }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="审核进度"
          prop="status"
          min-width="330px"
          align="left"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">-</span>
            <el-steps v-else :active="scope.row.shList.length" :space="150">
              <el-step
                v-for="m in scope.row.shList"
                :key="m.id"
                :title="m.bmmc"
                :description="m.xm + '(' + m.shsj + ')'"
                :status="m.status == 2 ? 'error' : m.shsj ? 'success' : 'wait'"
              >
                <template slot="description">
                  <el-popover
                    v-if="m.status == 0"
                    :key="m.id"
                    width="200"
                    placement="top-start"
                    trigger="hover"
                  >
                    <span v-html="m.bmyg.replace(/\n/g, '<br>')"></span>
                    <span slot="reference">{{
                      m.xm && m.xm.length > 8 ? m.xm.slice(0, 8) + "..." : m.xm
                    }}</span>
                  </el-popover>
                </template>
              </el-step>
            </el-steps>
          </template>
        </el-table-column>

        <el-table-column
          label="首次申请时间"
          prop="firstreviewtime"
          min-width="140px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.firstreviewtime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="最近申请时间"
          prop="lastapplytime"
          min-width="140px"
          align="left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.lastapplytime }}</span>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>
  
  <script>
import { getXmxxList } from "@/api/common.js";
import { exportPscxList, xmApplyList } from "@/api/pscx.js";
import { getZxzj } from "@/api/xmcbhs.js";
import Pagination from "@/components/Pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";

export default {
  // 列表分页
  name: "taskType",
  components: { Treeselect, Pagination },
  computed: {
    ...mapGetters(["deptUser", "user", "xgpg", "zxlc", "common"]),
  },
  filters: {
    // 状态显示转换
    typeStata(status) {
      const statusMap = {
        1: "待申请",
        2: "待审核",
        3: "审核通过",
        4: "审核不通过",
      };
      return statusMap[status];
    },
  },
  data() {
    // const rolesAllClass = [{ value: 0, name: '超级管理员' }, { value: 1, name: '普通管理员' }, { value: 2, name: '普通员工' }, { value: 3, name: '普通用户' }]
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      listLoading: false,
      height: 100,
      listQuery: {
        status: null,
        linkPointName: "",
        xmzt: ["1"],
        xmbh: null,
        planId: null,
        pglx: null,
        zxzj: null,
        applicant: null,
        page: 1,
        pageSize: 10,
      },
      list: [],
      statusList: [
        { value: 1, lable: "待申请" },
        { value: 2, lable: "待审核" },
        { value: 3, lable: "审核通过" },
        { value: 4, lable: "审核不通过" },
      ],
      gjdzList: [
        "效果评估策略制定",
        "效果评估报告编写",
        "对接年度计划",
        "制度评审",
        "规划咨询成果评审",
        "管理咨询成果评审",
      ],
      xmList: [],
      pglxList: [],
      zxzjList: [],
      total: 0,
      auditDialog: false,
      viewDialog: false,
    };
  },
  created() {
    this.getList();
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("common/fetchUserInfoAction").then(() => {
      // this.$store.dispatch("xgpg/fetchXmxxListAction", {
      //   range: 0,
      //   bmbh: this.user.bmbh,
      // });
    });
    this.$store.dispatch("common/fetchDictAction", {
      dictType: "xmgl_xmzt",
      type: "2",
    });
    this.$store.dispatch("xgpg/fetchPglxListAction");
    getXmxxList({
      bmbh: "",
      type: "2",
      range: "1",
      xmlx: "0",
      xmzt: this.listQuery.xmzt.join(","),
    }).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    getZxzj(this.listQuery.bmbh).then((res3) => {
      if (res3.code == 0) {
        this.zxzjList = res3.data;
      }
    });
  },
  methods: {
    getList() {
      this.listLoading = true;
      const p = { ...this.listQuery, xmzt: this.listQuery.xmzt.join(",") };
      xmApplyList(p).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 65;
        } else {
          this.listLoading = false;
        }
      });
    },
    search() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleChangeZl() {
      getTaskZlList(
        this.listQuery.name,
        this.listQuery.bmbh,
        this.listQuery.txlx
      ).then((res) => {
        if (res.code == 0) {
          this.zlList = res.data;
        }
      });
    },
    handleChangeXmzt(i) {
      this.listQuery.xmzt = i;
      getXmxxList({
        bmbh: "",
        type: "2",
        range: "1",
        xmlx: "0",
        xmzt: this.listQuery.xmzt.join(","),
      }).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          this.listQuery.xmbh = null;
        }
      });
    },
    handleChangeXm(e) {
      this.listQuery.planId = null;
      if (e && e != "") {
        this.$store.dispatch("xgpg/fetchPlanListAction", { range: 0, xmbh: e });
      }
    },
    //导出
    exportList() {
      const { xmbh, planId, linkPointName, pglx, zxzj, applicant, status } =
        this.listQuery;
      exportPscxList({
        xmbh,
        planId,
        linkPointName,
        pglx,
        zxzj,
        applicant,
        status,
        xmzt: this.listQuery.xmzt.join(","),
      }).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath; // 组装a标签
          const elink = document.createElement("a"); // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleShowAdvice(e) {
      this.$refs.audit.handleShowAdvice(e);
    },
    handleShowAdvice2(e) {
      this.$refs.view.handleShowAdvice(e);
    },
    getSon(temp) {
      this.auditDialog = temp;
      this.viewDialog = temp;
      this.getList();
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
</style>
  